import { render, staticRenderFns } from "./ships-menu.svg.vue?vue&type=template&id=70ef0838&"
import script from "./ships-menu.svg.vue?vue&type=script&lang=js&"
export * from "./ships-menu.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports